import {getAllGames, getGamesCategories} from "./game"
import {emailVerification, login} from "./login"
import {register} from "./register";
import {sendPayment} from "./payment";

export default {login, getAllGames, register, getGamesCategories, emailVerification, sendPayment}